import React from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import cx from 'classnames';

import ZolaItem from './ZolaColumnItem';

const UserColumnItem = ({
  fieldName, target, mapZolaColumn, unmapZolaColumn
}) => {
  const handleDrop = (item) => {
    const { assignment, name: zolaCol } = item;
    if (assignment !== null) unmapZolaColumn(assignment, zolaCol);
    mapZolaColumn(fieldName, zolaCol);
  }  
  const [{ isOver }, dropRef] = useDrop({
    accept: 'ZOLA_COL',
    drop: item => handleDrop(item),
    collect: monitor => ({ isOver: monitor.isOver() })
  });

  const targetClass = cx('item__target', {
    'hover': isOver
  });

  return (
    <div className="user-list__item">
      <span className="item__text">{fieldName}</span>
      {target !== null ? (
        <ZolaItem
          fieldName={target}
          assignment={fieldName}
          isTarget
          mapZolaColumn={mapZolaColumn}
          unmapZolaColumn={unmapZolaColumn}
        />
      ) : (
        <div className={targetClass} ref={el => dropRef(el)} />
      )}
    </div>
  );
}

UserColumnItem.propTypes = {
  fieldName: PropTypes.string,
  mapZolaColumn: PropTypes.func,
  unmapZolaColumn: PropTypes.func,
};

export default UserColumnItem;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/UserColumnItem.jsx